module.exports = __webpack_public_path__ + "img/Download(Button).f3177769.svg";